<template>
  <div>
  </div>
  </template>
<script>
import axios from '../../../plugins/axios'
import Swal from 'sweetalert2'
import FileDownload from 'js-file-download'
const ls = require('local-storage')
export default {
data: () => ({
  relatorio: ls.get('relatorio-estudante'),
  html: ``,
  titulo: 'O Cartão',
  config: ls.get('configuracoesReport')
}),
created  () {
  this.comporCard()
},
methods: {
  async comporCard () {
    try {
      let result = await axios({
        method: 'post',
        url: ls.get('urlFoto') + 'createCardStudent',
        data: {
          instituicao: ls.get('instituicaodescricao').toUpperCase(),
          logotipo: 'logotipo',
          namefile: ls.get('idPessoa'),
          urlinsignia: ls.get('logotipo'),
          sigla: ls.get('sigla'),
          templatename: ((this.$store.state.alunoscard.length && this.$store.state.alunoscard[0].idCurso < 25) ? 'cardstudent.docx' : 'cardstudentpolitecnico.docx'),
          alunos: this.$store.state.alunoscard
        }
      }).then((res) => res.data)
      if (result && result.value.length) {
        this.downloadFile()
      }
    } catch (error) {
      this.sair()
      Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao criar o documento'})
    } finally {
      this.sair()
    }
  },
  async downloadFile () {
    try {
      await axios({
        url: ls.get('urlFoto') + 'readfile/' + ls.get('idPessoa') + '.docx',
        method: 'GET',
        responseType: 'blob' // Important
      }).then(function (response) {
        FileDownload(response.data, 'cartão.docx')
        this.sair()
      })
    } catch (error) {
      this.sair()
    }
  },
  sair () {
    this.$store.state.isloading = false
    this.$store.state.showDialogGuia.cartao = false
  }
}
}

</script>